import { useToastContext } from "components/alert/ToastContext";
import BaseCadastro from "components/BaseCadastro";
import BaseDataTableEdit from "components/dataTableableEdit/BaseDataTableEdit";
import { Label } from "components/input/Label";
import ClassificacaoRequisito from "model/auditoria5s/ClassificacaoRequisito";
import { OpcaoRespostaRequisito } from "model/auditoria5s/requisitoAuditoria/OpcaoRespostaRequisito";
import RequisitoAuditoria from "model/auditoria5s/requisitoAuditoria/RequisitoAuditoria";
import { Checkbox } from "primereact/checkbox";
import { Column, ColumnEditorOptions } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import RequisitoAuditoriaService from "service/auditoria5s/RequisitoAuditoriaService";

const requisitoAuditoriaService = new RequisitoAuditoriaService();

export default function RequisitoAuditoriaCadastro() {

    const { setError, formState: { errors }, control, register, clearErrors } = useForm();

    const { msgAlerta } = useToastContext();

    const titulo = "Cadastro de Requisito"

    const [requisitoAuditoria, setRequisitoAuditoria] = useState<RequisitoAuditoria>(new RequisitoAuditoria());
    const [classificacoesRequisito, setClassificacoesRequisito] = useState<ClassificacaoRequisito[]>([]);

    useEffect(() => {
        requisitoAuditoriaService.classificacaoes().then((data) => {
            setClassificacoesRequisito(data);
        }).catch((err) => {
            console.error(err);
        });
    }, [])

    function validar() {

        if (!requisitoAuditoria.nome) {
            setError("nome", { type: "manual", message: "Nome é obrigatório" }, { shouldFocus: true })
            return false;
        }
        if (!requisitoAuditoria.classificacaoRequisito || !requisitoAuditoria.classificacaoRequisito.id) {
            setError("classificacaoRequisito", { type: "manual", message: "Classificação é obrigatória" }, { shouldFocus: true })
            return false;
        }


        return true;
    }

    function validarPersonalizado() {
        if (requisitoAuditoria.permiteResposta && requisitoAuditoria.tipoResposta === "MULTI_ESCOLHA" && requisitoAuditoria.opcoesResposta.length === 0) {
            msgAlerta("Nenhuma Opção informada", "Informe as opções de resposta");
            return false;
        }
        for (let i = 0; i < requisitoAuditoria.opcoesResposta.length; i++) {
            if (!requisitoAuditoria.opcoesResposta[i].resposta || requisitoAuditoria.opcoesResposta[i].resposta.trim() === "") {
                msgAlerta("Opção de resposta vazia", "Informe a resposta da opção de resposta");
                return false;
            }
        }
        return true;
    }

    const editorResposta = (options: ColumnEditorOptions) => {
        return <InputText value={options.rowData.resposta}
            onChange={(e) => {
                options.rowData['resposta'] = e.target.value;
                let requisito = { ...requisitoAuditoria };
                requisitoAuditoria.opcoesResposta[options.rowIndex] = options.rowData;
                setRequisitoAuditoria(requisito);
            }} style={{ width: '100%' }} maxLength={300}
        />
    }


    return (

        <BaseCadastro model={requisitoAuditoria} service={requisitoAuditoriaService} setModel={(value: RequisitoAuditoria) => setRequisitoAuditoria(value)}
            validar={() => validar()} validarPersonalizado={() => validarPersonalizado()}
            urlService="/requisitoAuditoria" pathCadastro="/requisitoAuditoria"
            tituloPagina={'Requisito'}
        >
            {titulo ?
                <div className="row">
                    <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
                </div>
                : null}

            <div style={{ display: "flex", marginTop: 4 }}>
                <Checkbox
                    checked={requisitoAuditoria.permiteResposta}
                    onChange={(e) => { setRequisitoAuditoria({ ...requisitoAuditoria, permiteResposta: e.checked as boolean }) }}
                    style={{ marginRight: 5 }}
                />
                <label>Permite resposta (Campo "Resposta" no App)</label>
            </div>

            {requisitoAuditoria.permiteResposta ? <div style={{ display: "flex", marginTop: 4 }}>
                <Checkbox
                    checked={requisitoAuditoria.respostaObrigatoria}
                    onChange={(e) => { setRequisitoAuditoria({ ...requisitoAuditoria, respostaObrigatoria: e.checked as boolean }) }}
                    style={{ marginRight: 5 }}
                />
                <label>Resposta obrigatória</label>
            </div> : null}
            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Nome</Label>
                <div className="col-sm-12">
                    <InputText required value={requisitoAuditoria.nome} style={{ width: '100%' }}
                        className={errors.nome ? "p-invalid" : ""}
                        {...register("nome", {
                            onChange: (e) => {
                                clearErrors("nome");
                                setRequisitoAuditoria({ ...requisitoAuditoria, nome: e.target.value })
                            }
                        })}
                    />
                </div>
                {errors.nome && errors.nome.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.nome?.message as string}</span> : null}
            </div>
            <div className="row">
                <Label className="col col-sm-12">Descrição</Label>
                <div className="col-sm-12">
                    <InputText required value={requisitoAuditoria.descricao} style={{ width: '100%' }}
                        onChange={(e) => setRequisitoAuditoria({ ...requisitoAuditoria, descricao: e.target.value })}
                    />
                </div>
            </div>
            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Classificação</Label>
                <div className="col-sm-12">
                    <Controller control={control} name="classificacaoRequisito" render={({ field }) => (
                        <Dropdown value={requisitoAuditoria.classificacaoRequisito} options={classificacoesRequisito}
                            style={{ width: '30%' }}
                            focusInputRef={field.ref}
                            onChange={(e) => {
                                clearErrors("classificacaoRequisito")
                                setRequisitoAuditoria({ ...requisitoAuditoria, classificacaoRequisito: e.target.value })
                            }}
                            optionLabel="nome" placeholder="Qualquer" className="p-column-filter" />
                    )} />
                </div>
                {errors.classificacaoRequisito && errors.classificacaoRequisito.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.classificacaoRequisito?.message as string}</span> : null}
            </div>

            {requisitoAuditoria.permiteResposta ? <div className="row">

                <Label className="col col-sm-12">Tipo de resposta</Label>
                <div className="col-sm-12">
                    <Controller control={control} name="tipoResposta" render={({ field }) => (
                        <Dropdown value={requisitoAuditoria.tipoResposta} options={requisitoAuditoriaService.getTiposResposta()}
                            style={{ width: '30%' }}
                            focusInputRef={field.ref}
                            onChange={(e) => {
                                clearErrors("tipoResposta")
                                setRequisitoAuditoria({ ...requisitoAuditoria, tipoResposta: e.target.value })
                            }}
                            optionLabel="label" optionValue="value" placeholder="Qualquer" className="p-column-filter" />
                    )} />
                </div>
            </div> : null}

            {requisitoAuditoria.permiteResposta && requisitoAuditoria.tipoResposta === "MULTI_ESCOLHA" ?
                <div className="row">
                    <div className="col col-sm-12 mt-2">
                        <BaseDataTableEdit
                            tituloLista="Opções de resposta"
                            getNewModel={() => new OpcaoRespostaRequisito()}
                            dataKey="key"
                            lista={requisitoAuditoria.opcoesResposta}
                            setLista={(value) => setRequisitoAuditoria({ ...requisitoAuditoria, opcoesResposta: value as OpcaoRespostaRequisito[] })}
                        >
                            <Column field="resposta" header="Resposta" editor={editorResposta} style={{ width: '80%' }} />
                        </BaseDataTableEdit>
                    </div>
                </div>
                : null}

        </BaseCadastro>
    )
}
